<script>
  export let spacing = "1em";
</script>

<style>
  div {
    flex-shrink: 1 !important;
    align-self: stretch;
  }
</style>

<div style="flex-basis: {spacing};">
  <slot />
</div>
